<template>
    <basic-container>
        <avue-crud v-if="reWrite"
                   :option="option"
                   :table-loading="loading"
                   :data="data"
                   :page.sync="page"
                   :permission="permissionList"
                   :before-open="beforeOpen"
                   v-model="form"
                   ref="crud"
                   @row-update="rowUpdate"
                   @row-save="rowSave"
                   @row-del="rowDel"
                   @search-change="searchChange"
                   @search-reset="searchReset"
                   @selection-change="selectionChange"
                   @current-change="currentChange"
                   @size-change="sizeChange"
                   @on-load="onLoad"
                   @refresh-change="onLoad"
        >
          <template slot="menu" slot-scope="scope">
            <el-button
              type="text"
              size="small"
              icon="el-icon-view"
              v-if="permission.questionnairetaskmain_view"
              @click="openQuestionnaireTaskViewDialog(scope.row)"
            >查看明细
            </el-button>
            <el-button
              type="text"
              size="small"
              icon="el-icon-thumb"
              v-if="permission.questionnairetaskmain_view"
              @click="createReport(scope.row)"
              :hidden="hideCreateReportBtn(scope.row)"
            >生成报告
            </el-button>
          </template>
        </avue-crud>
      <!--    任务明细弹窗-->
      <openTask ref="openTask"></openTask>
    </basic-container>
</template>

<script>
    import {add, getDetail, getList, remove, update,getTaskReport, generate} from "@/api/crmedical/questionnaire/task/questionnairetaskmain";
    import {mapGetters} from "vuex";
    import openTask from './questionnairetask';
    import {getProjectList} from "@/api/crmedical/project/project";
    export default {
      components: {
        openTask,
      },
        data() {
            return {
                form: {},
                query: {},
                loading: true,
                page: {
                    pageSize: 10,
                    currentPage: 1,
                    total: 0
                },
                selectionList: [],
              reWrite: false,
              tempProjectId: '',
              projectList: [],
              option: {
                height: 'auto',
                calcHeight: 50,
                tip: false,
                border: true,
                indexLabel:'序号',
                index: true,
                selection: true,
                columnBtn: false,
                refreshBtn: false,
                addBtn: false,
                editBtn: false,
                viewBtn: true,
                delBtn: false,
                searchMenuSpan: 6,
                labelWidth:120,
                column: [{
                  label: "主键",
                  prop: "id",
                  editDisplay: false,
                  addDisplay: false,
                  viewDisplay: false,
                  hide: true,
                },
                  {
                    label: "项目名称",
                    prop: "projectId",
                    type: 'tree',
                    searchClearable: false,
                    search: true,
                    dicUrl: '/api/v4ward/project/getProjectList',
                    props: {label: 'name', value: 'id'},
                  },
                  {
                    label: "任务名称",
                    prop: "name",
                    search: true,
                    maxlength: 30,
                    showWordLimit: true,
                    overHidden: true,
                  },
                  {
                    label: "合格比例（%）",
                    prop: "criterionScore",
                    labelWidth:120,
                    maxlength: 6,
                    showWordLimit: true,
                  },
                  {
                    label: "任务状态",
                    prop: "processStatus",
                    type: 'select',
                    search: true,
                    dataType: 'number',
                    dicUrl: 'api/blade-system/dict/dictionary?code=task_process_status',
                    props: { label: 'dictValue', value: 'dictKey' },
                  },
                  {
                    label: "填报类型",
                    prop: "informantType",
                    type: 'select',
                    search: true,
                    dataType: 'number',
                    dicUrl: 'api/blade-system/dict/dictionary?code=informant_type',
                    props: { label: 'dictValue', value: 'dictKey' },
                  },
                  {
                    label: "计算类型",
                    prop: "calculateType",
                    type: 'select',
                    dataType: 'number',
                    dicUrl: 'api/blade-system/dict/dictionary?code=calculate_type',
                    props: { label: 'dictValue', value: 'dictKey' },
                  },
                  {
                    label: "开始时间",
                    prop: "startTime",
                  },
                  {
                    label: "结束时间",
                    prop: "endTime",
                  },
                  {
                    label: '开始日期',
                    prop: 'dateStartRange',
                    searchRange: true,
                    search: true,
                    searchSpan: 10,
                    type: 'datetimerange',
                    format: 'yyyy-MM-dd HH:mm:ss',
                    valueFormat: 'yyyy-MM-dd HH:mm:ss',
                    editDisplay: false,
                    addDisplay: false,
                    viewDisplay: false,
                    span: 16,
                    hide: true,
                  },
                ]
              },
                data: []
            };
        },
        computed: {
            ...mapGetters(["permission"]),
            permissionList() {
                return {
                    addBtn: this.vaildData(this.permission.questionnairetaskmain_add, false),
                    viewBtn: this.vaildData(this.permission.questionnairetaskmain_view, false),
                    delBtn: this.vaildData(this.permission.questionnairetaskmain_delete, false),
                    editBtn: this.vaildData(this.permission.questionnairetaskmain_edit, false)
                };
            },
            ids() {
                let ids = [];
                this.selectionList.forEach(ele => {
                    ids.push(ele.id);
                });
                return ids.join(",");
            }
        },
      created() {
        //加载列表
        getProjectList({}).then((res) => {
          this.projectList = res.data;
          if (this.projectList.length > 0) {
            this.query.projectId = this.projectList[0].id;
            this.tempProjectId = this.projectList[0].id;
          }
          this.$nextTick(() => {
            this.reWrite = true;
          });
          //每次刷新页面时，开启房产搜索框默认显示第一个节点的名称
          this.firstDisplayFlag = true;
        });
      },
        methods: {
          hideCreateReportBtn(row){
            return row.processStatus === 3;
          },
          createReport(row){
            getTaskReport({taskMainId:row.id}).then((data) => {
              this.$confirm("总任务数："+data.data.sum+"    ，未执行："+data.data.notExecute+"    ，进行中："
                +data.data.underway+"       ，已完成："+data.data.finish+"     ，是否继续生成报告?", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              })
                .then(() => {
                  return generate({taskMainId:row.id,type:1}).then(() => {
                    this.onLoad();
                    this.$message.success('操作成功!');
                  });
                })
            });
          },
          getProjectNameById(projectId) {
            let projectName = '';
            this.projectList.forEach(function (value, index, array) {
              if (value.id === projectId) {
                projectName = value.name;
                return;
              }
            });
            return projectName;
          },
          openQuestionnaireTaskViewDialog(row){
              this.$refs.openTask.openSystemTypeDialog(row);
          },
            rowSave(row, loading, done) {
                add(row).then(() => {
                    loading();
                    this.onLoad();
                    this.$message.success('操作成功!');
                }, error => {
                    done();
                    console.log(error);
                });
            },
            rowUpdate(row, index, loading, done) {
                update(row).then(() => {
                    loading();
                    this.onLoad();
                    this.$message.success('操作成功!');
                }, error => {
                    done();
                    console.log(error);
                });
            },
            rowDel(row) {
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: row.id});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                    });
            },
            handleDelete() {
                if (this.selectionList.length === 0) {
                    this.$message.warning("请选择至少一条数据");
                    return;
                }
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: this.ids});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                        this.$refs.crud.toggleSelection();
                    });
            },
            beforeOpen(done, type) {
                if (["edit", "view"].includes(type)) {
                    getDetail({id:this.form.id}).then(({data}) => {
                        this.form = data;
                    });
                }
                done();
            },
          searchReset() {
            this.query.informantType = '';
            this.query.processStatus =  '';
            this.query.name = '';
            this.query.dateStartRange = [];
            this.firstDisplayFlag = true;
            this.onLoad();
          },
            searchChange(params,done) {
                this.query = params;
                this.page.currentPage = 1;
                done();
                this.onLoad();
            },
            selectionChange(list) {
                this.selectionList = list;
            },
            selectionClear() {
                this.selectionList = [];
                this.$refs.crud.toggleSelection();
            },
            currentChange(currentPage) {
                this.page.currentPage = currentPage;
            },
            sizeChange(pageSize) {
                this.page.pageSize = pageSize;
            },
          onLoad(page) {
            page = page || this.page;
            this.loading = true;
            if (this.query.dateStartRange) {
              this.query.timeStart = this.query.dateStartRange[0];
              this.query.timeEnd = this.query.dateStartRange[1];
              this.query.dateStartRange = '';
            }
            //如果加载列表时propertyParentId为空，则将propertyParentId置为当前的第一个房产小区
            if (!this.query.projectId ) {
              this.query.projectId = this.tempProjectId;
            }
            getList(
              Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
            ).then(({data}) => {
              this.page.total = data.total;
              this.data = data.records;
              this.loading = false;
              this.selectionClear();
              if (this.firstDisplayFlag) {
                let ent = document.querySelector('input[placeholder="项目名称"]');
                ent.value = this.getProjectNameById(this.query.projectId);
                this.tempProjectId = this.query.projectId;
                //关闭默然显示，重刷页面时才开启默认显示
                this.firstDisplayFlag = false;
              }
            });
          },
        }
    };
</script>

<style>
</style>
